import { render } from "./StockAnalysis.vue?vue&type=template&id=05599917&scoped=true"
import script from "./StockAnalysis.vue?vue&type=script&lang=js"
export * from "./StockAnalysis.vue?vue&type=script&lang=js"

import "./StockAnalysis.vue?vue&type=style&index=0&id=05599917&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05599917"]])

export default __exports__